import React, { Component } from 'react'
import PropTypes from 'prop-types'
import ReactDOM from 'react-dom'

import './index.scss'

class Overlay extends Component {

  constructor (props) {
    super(props)
    this.state = {
      isOpen: false
    }
    this.triggerOpen = this.triggerOpen.bind(this)
    this.handleClick = this.handleClick.bind(this)
  }

  componentDidMount () {
    this._mounted = true
    if (typeof this.props.open !== 'undefined') {
      if (this.props.open) {
        this.triggerOpen()
      }
    }
  }

  componentWillReceiveProps (nextProps) {
    if (typeof nextProps.open !== 'undefined') {
      if (this.props.open !== nextProps.open) {
        if (nextProps.open) {
          this.triggerOpen()
        }
      }
    }
    if (this.nextProps !== undefined && this.nextProps.checkForPopups !== undefined) this.nextProps.checkForPopups()
  }

  componentWillUnmount () {
    if (!this.props.dontHandleClick) {
      document.removeEventListener('click', this.handleClick, false)
    }
    this._mounted = false
  }

  triggerOpen (e) {
    if (e !== undefined) {
      e.preventDefault()
    }
    setTimeout(() => {
      if (this.props.checkForPopups !== undefined) this.props.checkForPopups()
    }, 100)
    if (!this.state.isOpen) {
      if (!this.props.dontHandleClick) {
        document.addEventListener('click', this.handleClick, false)
      }
      if (typeof this.props.openClick !== 'undefined') {
        this.props.openClick(true)
      }
    } else {
      if (typeof this.props.openClick !== 'undefined') {
        this.props.openClick(false)
      }
      if (!this.props.dontHandleClick) {
        document.removeEventListener('click', this.handleClick, false)
      }
    }

    this.setState({
      isOpen: !this.state.isOpen
    })
  }

  close () {
    document.removeEventListener('click', this.handleClick, false)
    this.setState({
      isOpen: false
    })
  }

  handleClick (e) {
    if (e.defaultPrevented === true) {
      e.preventDefault()
      return false
    }
    if (e.target.dataset.action === 'close') {
      if (this._mounted) {
        this.triggerOpen()
      }
      return false
    }
    let component = ReactDOM.findDOMNode(this.refs.component)
    if (e.target === component || component.contains(e.target) || this.props.allowExtraClasses.indexOf(e.target.className) !== -1) {
      if (e.target.tagName.toLowerCase() === 'a') {
        this.props.handleClick(e.target)
        if (e.target.dataset.action !== 'delete') {
          if (this._mounted) {
            this.triggerOpen()
          }
        }
      }
    } else {
      if (this._mounted) {
        this.triggerOpen()
      }
    }
  }

  render () {
    let actionMenu = ''
    if (this.state.isOpen) {
      actionMenu = this.props.renderActionMenu(this.triggerOpen)
    }

    return (
      <div className={this.props.className} ref='component'>
        {this.props.renderActionOpener(this.triggerOpen)}
        {actionMenu}
      </div>
    )
  }

}

Overlay.propTypes = {
  renderActionMenu: PropTypes.func.isRequired,
  renderActionOpener: PropTypes.func.isRequired
}

Overlay.defaultProps = {
  className: 'overlay',
  allowExtraClasses: [],
  renderActionOpener: (triggerOpen) => {
    return (
      <span onClick={triggerOpen}>
        <img src='/images/icons/menu_dots16.png' />
      </span>
    )
  },
  renderActionMenu: () => {
    return (
      <div className='poppedup'>Content</div>
    )
  }
}

export default Overlay



// WEBPACK FOOTER //
// ./src/app/shared/components/Overlay/index.js